// Bundle Type
export const TYPE_IMAGE_BUNDLES = 'image-bundles';
export const TYPE_AUDIO_BUNDLES = 'audio-bundles';
export const TYPE_TEMPLATES = 'templates';
